import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../services/api.service';
import { SupplierCategory, SupplierCategoryRequest } from '../purchased-order.model';
import { buildFilterQuery, buildHttpParams } from '../../utils';

@Injectable({
  providedIn: 'root',
})
export class SupplierCategoryService {
  private readonly baseUrl: string = 'supplier-categories/';

  constructor(private apiService: ApiService) {}

  /**
   * Unpaginated: the response is a plain array sorted by name, not a page object.
   * Do not hand this to a paginated response handler.
   */
  public list(filters: { search?: string | null } = {}): Observable<SupplierCategory[]> {
    const params = buildHttpParams(buildFilterQuery(filters));

    return this.apiService.get(this.baseUrl, params);
  }

  public post(reqBody: SupplierCategoryRequest): Observable<SupplierCategory> {
    return this.apiService.post(this.baseUrl, reqBody);
  }

  public patch(id: string, reqBody: SupplierCategoryRequest): Observable<SupplierCategory> {
    return this.apiService.patch(`${this.baseUrl}${id}/`, reqBody);
  }

  public delete(id: string): Observable<void> {
    return this.apiService.delete(`${this.baseUrl}${id}/`);
  }
}
